import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {AppState} from '../core.module';

import * as RouterActions from '../router/store/router.actions';
import * as AuthSelectors from '../auth/store/auth.selectors';

@Injectable()
export class EmailGuard implements CanActivate {
    email_exist: boolean;

    constructor (
        private store: Store<AppState>
    ) { }

    canActivate() {
        this.store.pipe(select(AuthSelectors.emailUpdated)).subscribe(res => this.email_exist = res);
        if (!this.email_exist) {
            this.store.dispatch(RouterActions.go({path: ['intro']}));
            return false;
        } else {
            return true;
        }
    }

}
